<template>
  <cms-video
    v-if="videoSetUp"
    :theme="videoOptions"
    :content="homepage.video[id]"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import isEmpty from 'lodash/isEmpty';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const store = useStore();

const theme = computed(() => store.state.theme);
const homepage = computed(() => store.state.homepage);
const isThemePreview = computed(() => store.state.isThemePreview);

const id = computed(() => (isThemePreview.value ? 'preview_id' : `${props.containerId}_${props.componentIdx}`));

const videoOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: store.getters['translation/getComponentTranslation']('video'),
    globalThemeSettings: store.getters.getGlobalThemeSettings,
  };
});

const videoSetUp = computed(() => {
  const videoList = homepage.value.video?.[id.value]?.videos || [];
  return !isEmpty(videoList) && videoList.some((video) => video.url);
});
</script>
